module.exports = "/img/arrow-left_white.svg?62bf5b3377ec5600b725631b4f30e9f6";